import React, { memo } from 'react'
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from 'react-sortable-hoc'
import { Icon } from 'antd'
import ShotCard from './ShotCard'

// DragHandle component
const DragHandle = SortableHandle(() => (
  <span
    className="drag-handle"
    style={{
      cursor: 'grab',
      marginRight: 8,
      display: 'inline-flex',
      alignItems: 'center'
    }}
  >
    <Icon type="drag" style={{ pointerEvents: 'none' }} />
  </span>
))

// Sortable Item Wrapper
const SortableItem = SortableElement(({ shot, shotIndex, ...props }) => (
  <ShotCard
    shot={shot}
    shotIndex={shotIndex}
    DragHandle={DragHandle}
    {...props}
  />
))

const SortableShotList = SortableContainer(
  ({
    shots,
    sceneId,
    formData,
    setFormData,
    handleDeleteShot,
    handleRegenerateImage,
    handleRegenerateWithReference,
    handleRegenerateWithReferenceNanoBanana,
    handleEditSettings,
    updateShotDataRef,
    handleFileUpload,
    handleCopyImageToShot,
    isUploadingImage,
    copyImageTargets,
    frameCopyTargets,
    videoId,
    imageProvider,
    isFetchingCharacters,
    shotViewMode = 'expanded'
  }) => {
    return (
      <div className={`shots-grid shots-grid--${shotViewMode}`}>
        {shots.map((shot, index) => (
          <SortableItem
            key={shot.id}
            index={index}
            shotIndex={index + 1}
            shot={shot}
            sceneId={sceneId}
            formData={formData}
            setFormData={setFormData}
            handleDeleteShot={handleDeleteShot}
            handleRegenerateImage={handleRegenerateImage}
            handleRegenerateWithReference={handleRegenerateWithReference}
            handleRegenerateWithReferenceNanoBanana={
              handleRegenerateWithReferenceNanoBanana
            }
            handleEditSettings={handleEditSettings}
            updateShotDataRef={updateShotDataRef}
            handleFileUpload={handleFileUpload}
            handleCopyImageToShot={handleCopyImageToShot}
            isUploadingImage={isUploadingImage}
            copyImageTargets={copyImageTargets}
            frameCopyTargets={frameCopyTargets}
            videoId={videoId}
            imageProvider={imageProvider}
            isFetchingCharacters={isFetchingCharacters}
            shotViewMode={shotViewMode}
          />
        ))}
      </div>
    )
  }
)

export default SortableShotList
